// extracted by mini-css-extract-plugin
module.exports = {"wrp":"contentWrp_wrp__VR50N","wrpOverflowFix":"contentWrp_wrpOverflowFix__ILvzm"};